import { FC } from 'react';

import { Button, downloadBlob } from '@qwealth/qcore';

import { useAppSelector } from 'data/store';
import { selectKyps } from 'data/selectors/kypSelectors';
import { Kyp } from 'data/models/Kyp';
import { format } from 'date-fns';

const KypCsvButton: FC = (): JSX.Element => {
  const kyps = useAppSelector<Kyp[]>(selectKyps);

  const formatKypFieldForCsv = (field: string, value: any): string => {
    switch (field) {
      case 'assessment':
        return JSON.stringify(value);

      case 'isApproved':
      case 'isExpired':
        return value ? 'Yes' : 'No';

      case 'feeStructure':
        return `${value}%`;

      case 'lastUpdated':
      case 'reviewDate':
      case 'startTime':
        if (!value) {
          return ''; // Blank null values to avoid Dec 1969
        }
        return JSON.stringify(format(new Date(value), 'MMMM d, yyyy'));

      default:
        return value;
    }
  };

  const convertKypArrayToCsv = (): string => {
    if (kyps.length < 1) return '';

    const allHeaders = Object.keys(kyps[0]);
    const headers = allHeaders.filter(h => h !== 'uuid');
    const csvRows = [
      headers.join(','),
      ...kyps.map(row =>
        headers
          .map(field => {
            return formatKypFieldForCsv(field, row[field]);
          })
          .join(','),
      ),
    ];
    return csvRows.join('\n');
  };

  const downloadCsv = () => {
    const csv = convertKypArrayToCsv();
    const csvBlob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const csvBlobUrl = URL.createObjectURL(csvBlob);
    downloadBlob(csvBlobUrl, 'KYPs.csv');
  };

  return (
    <Button variant="outline" disabled={kyps.length === 0} onClick={downloadCsv}>
      Download as CSV
    </Button>
  );
};

export default KypCsvButton;
